import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

// Components
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ConverterTool } from "@/components/ConverterTool";
import { FeaturesSection } from "@/components/FeaturesSection";
import { HowItWorksSection } from "@/components/HowItWorksSection";
import { SEOContentSection } from "@/components/SEOContentSection";
import { Footer } from "@/components/Footer";

function App() {
  // Initialize theme from localStorage or system preference
  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return savedTheme === 'dark' || (!savedTheme && systemPrefersDark);
  };

  const [isDarkMode, setIsDarkMode] = useState(() => {
    const dark = getInitialTheme();
    if (dark) {
      document.documentElement.classList.add('dark');
    }
    return dark;
  });

  // Toggle dark mode
  const toggleDarkMode = () => {
    setIsDarkMode((prev) => {
      const newValue = !prev;
      if (newValue) {
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
      }
      return newValue;
    });
  };

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      
      <main>
        <HeroSection />
        <ConverterTool />
        <FeaturesSection />
        <HowItWorksSection />
        <SEOContentSection />
      </main>
      
      <Footer />
      
      <Toaster 
        position="bottom-right" 
        richColors 
        closeButton 
        toastOptions={{
          style: {
            background: 'hsl(var(--card))',
            color: 'hsl(var(--card-foreground))',
            border: '1px solid hsl(var(--border))',
          },
        }}
      />
    </div>
  );
}

export default App;
